import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    accentColor: Palette['primary'];
  }
  interface PaletteOptions {
    accentColor?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/styles/createMixins' {
  interface Mixins {
    interFontStack: string;
  }
}

const defaultTheme: Theme = createTheme({
  spacing: 10,
  typography: {
    fontFamily: "'Inter', 'Arial', sans-serif !important",
    fontSize: 14,
    h1: { fontSize: '32px', fontWeight: 700 },
    h2: { fontSize: '24px', fontWeight: 700 },
    h3: { fontSize: '20px', fontWeight: 600 },
    h4: { fontSize: '18px', fontWeight: 600 },
    h5: { fontSize: '16px', fontWeight: 500 },
    h6: { fontSize: '14px', fontWeight: 500 },
    body1: { fontSize: '16px', fontWeight: 400 },
    body2: { fontSize: '14px', fontWeight: 400 },
    caption: { fontSize: '12px', fontWeight: 400 }
    /* allVariants: {
      color: '#3D3D3D'
    } */
  },
  mixins: {
    interFontStack: 'var(--inter-font-stack)'
  },
  palette: {
    mode: 'light',
    background: {
      default: '#f0f4f9',
      paper: '#FFFFFF'
    },
    accentColor: {
      main: '#7baf27'
    },
    primary: {
      main: '#7baf27'
    },
    secondary: {
      main: '#1c3443',
      contrastText: '#FFFFFF'
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    text: { primary: '#3D3D3D', secondary: '#FFFFFF' }
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 2, textTransform: 'capitalize', fontWeight: 600, padding: '5px 25px' } } },
    MuiRadio: { styleOverrides: { root: { color: '#7f8286' } } },
    MuiCheckbox: { styleOverrides: { root: { color: '#7f8286' } } },
    MuiIconButton: { styleOverrides: { root: { padding: '0px', color: '#3D3D3D' } } },
    MuiListItemAvatar: { styleOverrides: { root: { minWidth: 'auto', paddingRight: 5 } } },
    MuiListItem: {
      styleOverrides: {
        root: { paddingTop: 0, paddingBottom: 0 },
        container: { display: 'inline-block', border: '1px solid #1C3443', borderRadius: 15, padding: 5, marginRight: 10 },
        secondaryAction: { paddingRight: 5 }
      }
    },
    MuiListItemText: { styleOverrides: { root: { marginTop: 0, marginBottom: 0 }, primary: { fontSize: '11px', cursor: 'pointer' } } },
    MuiListSubheader: { styleOverrides: { root: { lineHeight: '1.2em' } } },
    MuiCardMedia: { styleOverrides: { root: { backgroundSize: 'contain' } } },
    MuiOutlinedInput: { styleOverrides: { input: { padding: '11.5px 14px' }, multiline: { padding: '11.5px 14px' } } },
    MuiFormControl: { styleOverrides: { marginNormal: { marginTop: 8 } } },
    MuiInput: { styleOverrides: { multiline: { padding: '0' } } },
    MuiChip: { styleOverrides: { outlined: { border: '1px solid #1C3443' } } },
    MuiMenuItem: { styleOverrides: { root: { padding: '6px 16px !important', fontSize: '14px', minWidth: '100px' } } },
    MuiListItemIcon: { styleOverrides: { root: { minWidth: 35, color: '#3D3D3D' } } },
    MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: '#3D3D3D', fontSize: '0.8rem' } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'capitalize' } } },
    MuiToolbar: { styleOverrides: { gutters: { padding: '0px 12px !important' } } }
  }
});

export default defaultTheme;
